// 设备查询--订单信息--订单详情
import React, { PureComponent } from "react";
import { Spin } from "antd";
// 国际化切换语言
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import fetchHandler from "@/fetch/fetchHandler";
import { getStubOrderDetailInfo } from "@/fetch/fetchApi";
// 样式
import "./index.styl";

const timeTypeMap = new Map([
  [1, "峰"],
  [2, "尖"],
  [3, "谷"],
  [4, "平"],
]);

@connect((state) => state)
class OrderDetailInfo extends PureComponent {
  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.orderDetailInfo;
    this.yunwei = this.props.intl.messages.commonBase;
    this.state = {
      result: {},
      detailInfo: this.props.orderDetailInfo,
      isShow: window.sessionStorage.getItem("companyId") === "1"
    };
    this.query = {};
    this.layout = [
      "inline", // 横向布局
      "horizontal", // 纵向布局
    ];
  }

  componentWillMount() {
    this.getStubDetail();
  }

  // 获取电桩详情
  getStubDetail() {
    fetchHandler(getStubOrderDetailInfo, {
      orderId: this.props.orderDetailInfo.key,
    }).then((res) => {
      if (res && (res.code === "ok" || res.code === "success")) {
        this.setState({
          result: res.data,
          stubSpinning: false,
        });
      } else {
        this.setState({
          result: [],
          stubSpinning: false,
        });
      }
    });
  }

  modalVisibleAction(modalVisibleKey, visible) {
    this.setState({
      [modalVisibleKey]: visible,
    });
  }

  formatterPrice = (data) => {
    if (!data || data.length === 0) {
      return "--";
    }

    const results = [];
    data.forEach((v) => {
      results.push(
        <div>
          <div>
            {`${timeTypeMap.get(v.timeType) || ""} ${v.startTime}~${v.endTime} 电价：${(
              v.totalPrice || 0
            ).toFixed(4)}`}
          </div>
          <div style={{ fontSize: 14, color: "#777" }}>
            {` (基础电价：${(v.basePrice || 0).toFixed(4)} 电损电价：${(v.lossPrice || 0).toFixed(
              4,
            )} 保利电价：${(v.profitPrice || 0).toFixed(4)} 服务费：${(v.servicePrice || 0).toFixed(
              4,
            )})`}
          </div>
        </div>,
      );
    });
    return results;
  };

  getStartTypeName = (data) => {
    switch (data) {
      case 0:
        return "未知";
      case 1:
        return "APP或微信启动";
      case 2:
        return "计费卡启动";
      case 3:
        return "不计费卡启动";
      case 4:
        return "按钮或屏幕启动";
      case 5:
        return "擦枪启动";
      case 6:
        return "命令启动";
      case 7:
        return "桩定时启动";
      case 8:
        return "银联卡启动";
      case 9:
        return "互联互通启动";
      case 10:
        return "辅枪启动";
      case 11:
        return "在线VIN";
      case 12:
        return "离线VIN";
      case 13:
        return "受电弓";
      case 14:
        return "在线蓝牙MAC启动";
      case 15:
        return "OCPP小票机";
      case 16:
        return "预约即插即充";
      case 17:
        return "vin即插即充";
      case 18:
        return "在线蓝牙启动";
      case 19:
        return "蓝牙即插即充";
      case 20:
        return "支付宝车生活启动";
      default:
        return "未知";
    }
  };

  render() {
    return (
      <Spin spinning={this.state.stubSpinning}>
        <div className="sc-modal-scroll">
          <div className="page-panel">
            <div className="page-info-item order-info-detail-content">
              <ul style={{ fontSize: 14, color: "#333" }}>
                {/* 业务订单号 */}
                <li className="stationName">
                  <strong>{this.internationalization.title1}：</strong>
                  <span>{this.state.result.outOrderId ? this.state.result.outOrderId : "--"}</span>
                </li>
                {/* 平台订单号 */}
                <li className="stationName">
                  <strong>{this.internationalization.title2}：</strong>
                  <span>{this.state.result.id ? this.state.result.id : "--"}</span>
                </li>
                {/* 设备编号 */}
                <li className="stationName">
                  <strong>{this.internationalization.title8}：</strong>
                  <span>{this.state.result.stubId ? this.state.result.stubId : "--"}</span>
                </li>
                {/* 电站名称 */}
                <li className="stationName">
                  <strong>{this.internationalization.title10}：</strong>
                  <span>
                    {this.state.result.stubGroupName ? this.state.result.stubGroupName : "--"}
                  </span>
                </li>
                {/* 地区 */}
                <li className="stationName">
                  <strong>地区：</strong>
                  <span>{this.state.result.cityName ? this.state.result.cityName : "--"}</span>
                </li>
                {/* 用户编号 */}
                <li className="stationName">
                  <strong>用户编号：</strong>
                  <span>{this.state.result.userId ? this.state.result.userId : "--"}</span>
                </li>
                {/* 运营类型 */}
                <li className="stationName">
                  <strong>运营类型：</strong>
                  <span>
                    {this.state.result.operationMode ? `${this.state.result.operationMode}` : "--"}
                  </span>
                </li>
                {/* 充电应用 */}
                <li className="stationName">
                  <strong>充电应用：</strong>
                  <span>{this.state.result.appkeyName ? this.state.result.appkeyName : "--"}</span>
                </li>
                { this.state.isShow ?
                  /* 车型号 */
                  <li className="stationName">
                    <strong>{this.internationalization.title3}：</strong>
                    <span>
                      {this.state.result.carTypeName ? this.state.result.carTypeName : "--"}
                    </span>
                  </li>
                : null }
                { this.state.isShow ?
                  /* 车辆VIN码 */
                  <li className="stationName">
                    <strong>{this.internationalization.title5}：</strong>
                    <span>{this.state.result.vin ? this.state.result.vin : "--"}</span>
                  </li>
                : null }
                { this.state.isShow ?
                  /* 车牌号 */
                  <li className="stationName">
                    <strong>{this.internationalization.title4}：</strong>
                    <span>
                      {this.state.result.carLicenseNo ? this.state.result.carLicenseNo : "--"}
                    </span>
                  </li>
                : null }
                {/* 充电时间 */}
                <li className="stationName">
                  <strong>{this.internationalization.title6}：</strong>
                  <span>
                    {this.state.result.timeStart || this.state.result.timeEnd
                      ? `${this.state.result.timeStart ? this.state.result.timeStart : ""}--${
                          this.state.result.timeEnd ? this.state.result.timeEnd : ""
                        }`
                      : "--"}
                  </span>
                </li>
                {/* 实际充电时间： */}
                <li className="stationName">
                  <strong>{this.internationalization.title7}：</strong>
                  <span>
                    {this.state.result.realStartTime || this.state.result.realEndTime
                      ? `${
                          this.state.result.realStartTime ? this.state.result.realStartTime : ""
                        }--${this.state.result.realEndTime ? this.state.result.realEndTime : ""}`
                      : "--"}
                  </span>
                </li>
                {/* 充电时长 */}
                <li className="stationName">
                  <strong>{this.internationalization.title9}：</strong>
                  <span>{this.state.result.timeChargeFormat}</span>
                </li>
                {/* 充电电量(度) */}
                <li className="stationName">
                  <strong>{this.internationalization.title11}：</strong>
                  <span>{this.state.result.power}</span>
                </li>
                { this.state.isShow ?
                  /* 充电金额(元) */
                  <li className="stationName">
                    <strong>充电金额(元)：</strong>
                    <span>{this.state.result.feeTotal}</span>
                  </li>
                : null }
                {/* 充电状态 */}
                <li className="stationName">
                  <strong>{this.internationalization.title12}：</strong>
                  <span>
                    {this.state.result.status === 0 ? this.internationalization.state1 : ""}
                    {this.state.result.status === 1 ? this.internationalization.state2 : ""}
                    {this.state.result.status !== 0 && this.state.result.status !== 1
                      ? this.internationalization.state3
                      : ""}
                  </span>
                </li>
                {/* 停止原因 */}
                <li className="stationName">
                  <strong>{this.internationalization.title14}：</strong>
                  <span>{this.state.result.endInfo ? this.state.result.endInfo : "--"}</span>
                </li>
                { this.state.isShow ?
                  /* 手机号 */
                  <li className="stationName">
                    <strong>手机号：</strong>
                    <span>{this.state.result.telephone ? this.state.result.telephone : "--"}</span>
                  </li>
                : null }
                {/* 设备编号 */}
                <li className="stationName">
                  <strong>设备编号：</strong>
                  <span>{this.state.result.modelNo ? this.state.result.modelNo : "--"}</span>
                </li>
                {/* 实时功率 */}
                <li className="stationName">
                  <strong>实时功率：</strong>
                  <span>
                    {this.state.result.chargeKw != undefined && this.state.result.chargeKw != null
                      ? this.state.result.chargeKw
                      : "--"}
                  </span>
                </li>

                {/* 停止原因明细 */}
                <li className="stationName" style={{ flex: "0 0 100%" }}>
                  <strong>停止原因明细：</strong>
                  <span>
                    {this.state.result.endInfoDetail ? this.state.result.endInfoDetail : "--"}
                  </span>
                </li>
                { this.state.isShow ?
                  <li className="stationName" style={{ flex: "0 0 100%", paddingLeft: "0" }}>
                    <strong>充电价格：</strong>
                    <span>{this.formatterPrice(this.state.result.tariffs)}</span>
                  </li>
                : null }
                { this.state.isShow ?
                  <li className="stationName" style={{ flex: "0 0 100%" }}>
                    <strong>客户手机号：</strong>
                    <span>{this.state.result.telephone ? this.state.result.telephone : "--"}</span>
                  </li>
                : null }
                <li className="stationName" style={{ flex: "0 0 100%" }}>
                  <strong>启动方式：</strong>
                  <span>{this.getStartTypeName(this.state.result.startType)}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </Spin>
    );
  }
}

export default injectIntl(OrderDetailInfo);



// WEBPACK FOOTER //
// ./src/AntD/pages/configurationManagement/stub/orderDetailInfo.js